import { Col, Flex, Form, Input, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { t } from 'i18next'
import { CircleMarker, MapContainer, TileLayer, useMapEvents } from 'react-leaflet'
import { Color } from '../../Common/Color'

export default function BoxLocationTab ({ form, mapVisible }) {
  const [map, setMap] = useState(null)
  const [center, setCenter] = useState()

  useEffect(() => {
    map?.invalidateSize()
    const gpsPoint = form.getFieldValue('gps_point')
    if (gpsPoint) {
      const newCenter = gpsPoint ? gpsPoint.split(' ').reverse() : null
      setCenter(newCenter)
      map?.setView(newCenter, map.getZoom())
    }
  }, [mapVisible, map])

  const onGpsChange = (e) => {
    if (/^-?[0-9]+\.?[0-9]* -?[0-9]+\.?[0-9]*$/g.test(e.target.value)) {
      const newCenter = e.target.value.split(' ').reverse()
      setCenter(newCenter)
    }
  }

  const LocationFinderDummy = () => {
    useMapEvents({
      click (e) {
        form.setFieldsValue({ gps_point: `${e.latlng.lng} ${e.latlng.lat}` })
        setCenter([e.latlng.lat, e.latlng.lng])
      }
    })
    return null
  }

  return (
    <Flex justify='space-between'>
      <div style={{ width: '45%' }}>
        <h3>{t('Admin.BoxForm.group.address')}</h3>
        <Row gutter={[16, 16]}>
          <Col>
            <Form.Item name="city" label={t('Admin.BoxForm.city')}
              rules={[{ required: true, message: t('rules.required') }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="zip_code" label={t('Admin.BoxForm.zip_code')}
              rules={[{ required: true, message: t('rules.required') }]}>
              <Input type="number" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item name="address" label={t('Admin.BoxForm.address')}
          rules={[{ required: true, message: t('rules.required') }]}>
          <Input />
        </Form.Item>
        <Form.Item name="extra_address" label={t('Admin.BoxForm.extra_address')}>
          <Input />
        </Form.Item>
        <Form.Item name="gps_point" label={t('Admin.BoxForm.gps')}
          rules={[{ required: true, pattern: /^-?[0-9]+\.?[0-9]* -?[0-9]+\.?[0-9]*$/g }]}
        >
          <Input onChange={onGpsChange} />
        </Form.Item>
      </div>
      <div style={{ width: '50%' }}>
        {mapVisible && <MapContainer
          ref={setMap}
          style={{ borderRadius: '2em', height: '500px', width: '100%' }} center={center || [48.856614, 2.3522219]} zoom={13} scrollWheelZoom={true}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {center && <CircleMarker center={center} radius={8} pathOptions={{ divor: Color.white, fillColor: Color.red, weight: 2, fillOpacity: 1 }}></CircleMarker>}
          <LocationFinderDummy />
        </MapContainer>}
      </div>
    </Flex>
  )
}
